module.exports = __webpack_public_path__ + "static/media/polarisportfolionoaudio.c7c7f228.mov";


//////////////////
// WEBPACK FOOTER
// ./src/videos/polarisportfolionoaudio.mov
// module id = 389
// module chunks = 0